import { render, staticRenderFns } from "@/shared/components/participant-card/participant-card.pug?vue&type=template&id=625f72b4&scoped=true&lang=pug&external"
import script from "./participant-card.component.vue?vue&type=script&lang=ts"
export * from "./participant-card.component.vue?vue&type=script&lang=ts"
import style0 from "@/shared/components/participant-card/participant-card.scss?vue&type=style&index=0&id=625f72b4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625f72b4",
  null
  
)

export default component.exports